// utils/privateroute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element, authenticated }) => {
  return authenticated ? (
    element
  ) : (
    <Navigate to="/" replace state={{ from: '/' }} />
  );
};

export default PrivateRoute;
